import React from "react";
import { DataTable } from "carbon-components-react";
import filesize from "filesize";
import moment from "moment";

import "./App.scss";
import * as har from "./met-har.json";

// Firebase App (the core Firebase SDK) is always required and must be listed first
import * as firebase from "firebase/app";
// If you enabled Analytics in your project, add the Firebase SDK for Analytics
import "firebase/analytics";
// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB3gOGuqZVA8r-plqz4znoThV-ptOVfRjQ",
  authDomain: "shar-app.firebaseapp.com",
  databaseURL: "https://shar-app.firebaseio.com",
  projectId: "shar-app",
  storageBucket: "shar-app.appspot.com",
  messagingSenderId: "35104071899",
  appId: "1:35104071899:web:a5d83d268d345bc0262cfe",
  measurementId: "G-9PYT50MRB4"
};

firebase.initializeApp(firebaseConfig);

const {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  TableHeader
} = DataTable;

const App: React.FC = () => {
  const headers = [
    {
      header: "Method",
      key: "requestMethod"
    },
    {
      header: "Domain",
      key: "domain"
    },
    {
      header: "URL",
      key: "url"
    },
    {
      header: "Response Code",
      key: "responseCode"
    },
    {
      header: "Response Type",
      key: "responseType"
    },
    {
      header: "Response Size",
      key: "responseSize"
    },
    {
      header: "Response Time",
      key: "responseTime"
    }
  ];

  const getReadableUrl = (urlStr: string) => {
    const url = new URL(urlStr);
    // build a readable url
    let readableUrl = "";
    if (url.pathname.length > 20) {
      readableUrl += `${url.pathname.substring(0, 20)}...`;
    } else {
      readableUrl += url.pathname;
    }
    if (url.search) {
      if (url.search.length > 10) {
        readableUrl += `${url.search.substring(0, 10)}...`;
      } else {
        readableUrl += url.search;
      }
    }
    return readableUrl;
  };

  const humanizeResponseTime = (time: number) => {
    // NOTE: does not account for response time in the hours or more
    let output = "";
    const dur = moment.duration(time);
    output += dur.minutes() ? `${dur.minutes()} minutes ` : "";
    output += dur.seconds() ? `${dur.seconds()} seconds ` : "";
    output += dur.milliseconds() ? `${Math.round(dur.milliseconds())} ms ` : "";

    return output;
  };

  const rows = har.log.entries.map(entry => {
    const url = new URL(entry.request.url);
    return {
      id: `${entry.startedDateTime}-${entry.request.method}-${
        entry.request.url
      }`,
      url: getReadableUrl(entry.request.url),
      requestMethod: entry.request.method,
      domain: url.hostname,
      responseCode: entry.response.status,
      responseType: entry.response.content.mimeType,
      responseSize: filesize(entry.response.content.size),
      responseTime: humanizeResponseTime(entry.time)
    };
  });

  return (
    <div className="App">
      <div className="bx--grid bx--grid--full-width">
        <div className="bx--row">
          <h1>sHAR</h1>
        </div>
        <div className="bx--row"><p>Share HAR files to help paint a better picture when analyzing or debudding web apps / network requests.</p></div>
        <div className="bx--row"><p><b>WORK IN PROGRESS. Coming later: request headers, uploading HAR files, highlighting specific requests/items etc.</b></p></div>
        <div className="bx--row"><p>See a sample HAR below</p></div>

        <div className="bx--row">
          <DataTable
            headers={headers}
            rows={rows}
            render={({ rows, headers, getHeaderProps }) => (
              <TableContainer title="Requests">
                <Table>
                  <TableHead>
                    <TableRow>
                      {headers.map(header => (
                        <TableHeader {...getHeaderProps({ header })}>
                          {header.header}
                        </TableHeader>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map(row => (
                      <TableRow key={row.id}>
                        {row.cells.map(cell => (
                          <TableCell key={cell.id}>{cell.value}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default App;
